/*
  getUniqueNodeId.js
*/

// Util.
import getRandomId from './getRandomId';

/**
 * Helper to get a unique ID for a node.
 */
export default function getUniqueNodeId(graphData) {

  // Get existing IDs.
  const existingIds = new Set();
  if (graphData?.nodes) {
    for (const node of graphData.nodes) {
      if (node.id) {
        existingIds.add(node.id);
      }
    }
  }

  // Generate a new unique ID.
  let id = getRandomId();
  while (existingIds.has(id)) {
    id = getRandomId();
  }
  return id;

}
